// extracted by mini-css-extract-plugin
export default {"wrapper":"Label_wrapper__lvYZv","star":"Label_star__Q8Jpx","title":"Label_title__AbZt-"};